import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from '@reach/router';
import tw, {styled} from 'twin.macro';
import SimpleFormContainer from 'components/SimpleFormContainer';
import SimpleFormHeading from 'components/SimpleFormHeading';
import SimpleFormPage from 'components/SimpleFormPage';
import Button from 'components/Button';

function NoWorkspaceAccessPage () {
  return <>
    <Helmet>
      <title>You don’t have access yet</title>
    </Helmet>
    <SimpleFormPage>
      <SimpleFormContainer>
        <SimpleFormHeading>You don’t have access yet</SimpleFormHeading>
        <Message>
          You have not yet been added to a workspace in AirManual.
        </Message>
        <Message>
          If you believe you should have access, please contact your workspace
          admin.
        </Message>
        <Link to="/logout">
          <Button>Log out</Button>
        </Link>
      </SimpleFormContainer>
    </SimpleFormPage>
  </>;
}

const Message = styled.p((props) => [
  tw`
    text-gray-600
    mb-4
  `,
]);

export default NoWorkspaceAccessPage;
